module.exports = __webpack_public_path__ + "media/images/email/ouija_banner-f04127e82565533e048f377c82a0d98f.jpg";